export const commonStatusOptions = [
    {text: '全部', value: null},
    {text: '启用', value: 1},
    {text: '禁用', value: 0},
]

export const dealerStatusOptions = [
    {text: '全部', value: null},
    {text: '未审核', value: 0},
    {text: '已审核', value: 2},
    {text: '审核中', value: 1},
    {text: '终止', value: 3},
]

export const dealerQualificationOptions = [
    {text: '全部', value: null},
    {text: '2类', value: 2},
    {text: '3类', value: 3},
]
